export default {
  optional: 'Optional',
  agreeField: 'Please read and accept the notice',
  radioCheckbox: 'Please answer the question',
  birthDate: {
    max: 'The age entered is above the maximum allowed.',
    min: 'The age entered is below the minimum required.',
  },
};
